var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('PageTitle',{attrs:{"title":"About Hacker News"}}),_c('h2',[_vm._v("This is a read-only web client for Hacker News!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }